import React from "react"
import styled from "styled-components"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import Styled from "../components/styled"

const TITLE = `Sidan hittades inte`

export default function NotFoundPage() {
  return (
    <Layout>
      <Container>
        <Styled>
          <h1>{TITLE}</h1>

          <p>Sidan du letar efter kunde inte hittas</p>
        </Styled>
      </Container>
    </Layout>
  )
}

export const Head = () => {
  return <Meta data={{ title: TITLE }} />
}

const Container = styled.ul`
  ${({ theme }) => theme.grid.container()}

  min-height: 50vh;
  display: flex;
  align-items: center;
  text-align: center;

  > * {
    width: 100%;
  }
`
